import { createIconModule, FluentIconStyleProvider } from 'owa-fluent-icons-svg';
import CheckmarkFilled from 'owa-fluent-icons-svg/lib/icons/CheckmarkFilled';
import CheckboxUncheckedRegular from 'owa-fluent-icons-svg/lib/icons/CheckboxUncheckedRegular';
import CheckboxCheckedFilled from 'owa-fluent-icons-svg/lib/icons/CheckboxCheckedFilled';
import { TagDuoToneIcon } from './TagDuoToneIcon';
import { TagFilled, TagRegular } from '@fluentui/react-icons';
import { tagWrapper, tagFill, tagOutline } from './TagDuoToneChecked.scss';
/* eslint-disable-next-line @fluentui/react-components/prefer-fluentui-v9 -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE! Substitute this line with an explanation or resolve the problem by using v9 components instead
 *	> Avoid using Icon from '@fluentui/react', as this package has already migrated to Fluent UI 9. Use a JSX SVG icon from '@fluentui/react-icons' instead. */
import { Icon } from '@fluentui/react/lib/Icon';
import { getPalette } from 'owa-theme';

const rootStyle = {
    width: '1em',
    height: '1em',
    display: 'inline-flex',
};
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function getPalette called at module scope is not allowed. This may cause unwanted side effects. */
const checkmarkFilledIconStyle = { color: getPalette().neutralPrimary, marginRight: '4px' };

// Layout for the checkbox + tag pair.
const compositeStyle = {
    display: 'inline-flex',
    alignItems: 'center',
};

// No color here so the checkbox inherits acui's iconColor, which is stripped in Windows High Contrast.
const checkboxWrapperStyle = {
    display: 'inline-flex',
    width: '1em',
    height: '1em',
    marginRight: '4px',
};

// Duotone tag rendering (both filled interior and outline) lives in TagDuoToneChecked.scss; colors are fed via --owaCategoryTagColor / --owaCategoryTagFillColor by the caller.

function TagDuoToneBundle() {
    return (
        <FluentIconStyleProvider rootStyle={rootStyle}>
            <Icon iconName={CheckmarkFilled} style={checkmarkFilledIconStyle} />
            <Icon iconName={TagDuoToneIcon} />
        </FluentIconStyleProvider>
    );
}

function TagDuoToneCheckboxBundle() {
    return (
        <span style={compositeStyle}>
            <span style={checkboxWrapperStyle}>
                <Icon iconName={CheckboxUncheckedRegular} />
            </span>
            <span className={tagWrapper}>
                <TagFilled className={tagFill} />
                <TagRegular className={tagOutline} />
            </span>
        </span>
    );
}

function TagDuoToneCheckboxFilledBundle() {
    return (
        <span style={compositeStyle}>
            <span style={checkboxWrapperStyle}>
                <Icon iconName={CheckboxCheckedFilled} />
            </span>
            <span className={tagWrapper}>
                <TagFilled className={tagFill} />
                <TagRegular className={tagOutline} />
            </span>
        </span>
    );
}

const defaultExport: 'TagDuoToneChecked' = createIconModule('TagDuoToneChecked', TagDuoToneBundle);
export default defaultExport;

export const TagDuoToneCheckbox: 'TagDuoToneCheckbox' = createIconModule(
    'TagDuoToneCheckbox',
    TagDuoToneCheckboxBundle
);

export const TagDuoToneCheckboxFilled: 'TagDuoToneCheckboxFilled' = createIconModule(
    'TagDuoToneCheckboxFilled',
    TagDuoToneCheckboxFilledBundle
);
